/* eslint-disable no-unsafe-optional-chaining */
// @ts-nocheck
export const mapExpandTaskData = (object) => {
  // Execution time
  // const t1 = performance.now();
  const value = {
    task: [],
    sub_task: [],
    sub_sub_task: [],
    resource: [],
    cost_center: [],
  };
  const getValueAndCount = (data) => {
    Object.keys(data)?.map((key) => {
      if (Array.isArray(data[key])) {
        data[key].map((eachData) => getValueAndCount(eachData));
      }
    });
    if (Object.keys(data)?.includes('id')) {
      const appendValue = (name = 'resource') => {
        if (value[name]?.length) {
          value[name] = [...value?.[name], data?.id];
        } else {
          value[name] = [data?.id];
        }
      };
      const { task_type } = data;
      appendValue(task_type);
    }
  };
  getValueAndCount(object);
  // const t2 = performance.now();
  return value;
};
